export function is375Query() {
  return window.matchMedia('(min-width: 375px)').matches;
}

export function is400Query() {
  return window.matchMedia('(min-width: 400px)').matches;
}

export function is500Query() {
  return window.matchMedia('(min-width: 500px)').matches;
}

export function is640Query() {
  return window.matchMedia('(min-width: 640px)').matches;
}

export function is768Query() {
  return window.matchMedia('(min-width: 768px)').matches;
}

export function is960Query() {
  return window.matchMedia('(min-width: 960px)').matches;
}

export function is1200Query() {
  return window.matchMedia('(min-width: 1200px)').matches;
}

export function is1400Query() {
  return window.matchMedia('(min-width: 1400px)').matches;
}

export function is1600Query() {
  return window.matchMedia('(min-width: 1600px)').matches;
}

export function is2000Query() {
  return window.matchMedia('(min-width: 2000px)').matches;
}

export function isTouchDevice() {
  return 'ontouchstart' in document.documentElement;
}
